<ng-container *ngIf="!processing.configurationFile">
    <div class="wrapper">
        <!-- top navbar-->
        <app-header class="topnavbar-wrapper"></app-header>
        <!-- sidebar-->
        <app-sidebar class="aside-container"></app-sidebar>
        <!-- Main section-->
        <section class="section-container">
            <!-- Page content-->
            <div class="content-wrapper">
                <router-outlet></router-outlet>
            </div>
        </section>
        <!-- Page footer-->
        <app-footer class="footer-container"
            app-footer></app-footer>
    </div>
</ng-container>
